import { Injectable } from '@angular/core';
import { JWTService } from 'src/app/shared/jwt.service';
import { PageService } from 'src/app/shared/page.service';

@Injectable({ providedIn: 'root' })
export class CustomizationResolver {
  constructor(private pageService: PageService, private jwtService: JWTService) {}

  resolve() {
    if (!this.jwtService.getJwt()) {
      return this.pageService.getPageInfo();
    }
    return Promise.resolve();
  }
}
